import { Modal } from 'react-bootstrap';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import { Input } from '../../../common/Forms/Input/Input';
import './LandingModals.scss';
import {
  idCodes,
  banksOptions
} from '../../../../assets/helpers/options';
import { MethodLogoContainer, AmounComponent } from "./LandingModals"


export const CashbackModal = (props) => {
  const {
    cancelPayment,
    acceptPayment,
    options,
    register,
    errors,
    payment,
  } = props;

  return (
    <Modal
      size="lg"
      centered
      show={payment?.isOpen}
      onHide={() => cancelPayment(payment?.paymentNumber)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="landing-payment-modal-header">
          <AmounComponent
            amount={payment?.amount}
            amountBsS={payment?.amountBsS}
          />

          <MethodLogoContainer methods={payment?.methods} />
        </div>
        <div className="landing-payment-modal-body">
          <h6 className="landing-payment-modal-title">Datos de Pago</h6>
          <div
            style={{ width: '100%' }}
            className="row landing-payment-modals-form"
          >
          </div>
          <div className="row">
            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Metodo de pago de Vuelto* '}
              type={'select'}
              options={options?.paymentMethodOptions}
              name={`returnedMethod${payment?.paymentNumber}`}
              placeholder={''}
              register={register}
              errors={errors?.[`returnedMethod${payment?.paymentNumber}`]?.message}
              disabled={true}
            />

            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Nro. Teléfono asociado a pago móvil *'}
              type={'number'}
              name={`cashBackphone${payment?.paymentNumber}`}
              placeholder={'4143579865'}
              register={register}
              errors={errors?.[`cashBackphone${payment?.paymentNumber}`]?.message}
              disabled={false}
            />
            <Input
              bootstrap={'col-4 col-sm-2 col-md-6'}
              label={'Banco *'}
              name={`cashBackbank${payment?.paymentNumber}`}
              options={banksOptions}
              type={'select'}
              register={register}
              placeholder={''}
              errors={errors?.[`cashBackbank${payment?.paymentNumber}`]?.message}
            />
            <Input
              bootstrap={'col-4 col-sm-2 col-md-2'}
              label={'C.I / RIF*'}
              type={'select'}
              name={`cashBackIdentificationType${payment?.paymentNumber}`}
              register={register}
              placeholder={''}
              options={idCodes}
              errors={errors?.[`cashBackIdentificationType${payment?.paymentNumber}`]?.message}
            />{' '}
            <Input
              bootstrap={'col-8 col-sm-4 col-md-4'}
              label={'del titular*'}
              type={'number'}
              name={`cashBackIdentification${payment?.paymentNumber}`}
              register={register}
              placeholder={''}
              errors={errors?.[`cashBackIdentification${payment?.paymentNumber}`]?.message}
            />{' '}
          </div>
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton
          label={`Cancelar `}
          action={() => cancelPayment(payment?.paymentNumber)}
        />
        <ActionButton label={`Pagar `} action={() => acceptPayment()} />
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};
